<template>
  <div class="text-center">
    <v-img
      :src="require('@/assets/img/scrap.png')" aspect-ratio="1"
      max-width="96" class="mx-auto mb-2"
    />
    <h3 class="text-h6">
      Free {{ reward.data.amount | toScrap }} Scrap
    </h3>
  </div>
</template>

<script>
export default {
  props: {
    reward: {
      type: Object,
      required: true,
    },
  },
}
</script>
